import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const QuoteIcon: React.FC<IProps> = (props) => {
	return (
		<svg
			width="46"
			height="42"
			viewBox="0 0 46 42"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M11.5 1L18.0714 8.28889C13.7426 13.0469 11.3957 18.0833 11.0306 23.3981H19.4014V42H0V28.1815C0 23.7272 0.886621 19.0704 2.65986 14.2111C4.48526 9.35185 7.43197 4.94815 11.5 1ZM38.0986 1L44.8265 8.28889C40.1848 12.9457 37.7857 17.9821 37.6292 23.3981H46V42H26.5986V28.0296C26.5986 18.0074 30.432 8.99753 38.0986 1Z"
				fill="currentColor"
			/>
			<path
				d="M11.5 0L18.0714 7.28889C13.7426 12.0469 11.3957 17.0833 11.0306 22.3981H19.4014V41H0V27.1815C0 22.7272 0.886621 18.0704 2.65986 13.2111C4.48526 8.35185 7.43197 3.94815 11.5 0ZM38.0986 0L44.8265 7.28889C40.1848 11.9457 37.7857 16.9821 37.6292 22.3981H46V41H26.5986V27.0296C26.5986 17.0074 30.432 7.99753 38.0986 0Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default memo(QuoteIcon);
